import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { cargoTypes, cargoQualityValues } from "dora-contracts";
import { useAppDispatch, useSelector } from "../../../redux-store";
import {
  selectVisibleCargoQualities,
  selectVisibleCargoRequirements,
  selectVisibleCargoTypes,
} from "../../../ducks/data/teams/selectors";
import { loadTeams } from "../../../ducks/data/teams";
import { useFeature } from "../../../hooks";

const useShipmentFormSelectTeamRelatedOptions = ({
  selectedTeamId,
}: {
  selectedTeamId: string;
}) => {
  const dispatch = useAppDispatch();
  const isTeamsCargosTypesQualitiesRequirementsEnabled = useFeature(
    "teams-cargo-types-qualities-requirements"
  );
  const assignedTeamCargoTypes = useSelector(
    selectVisibleCargoTypes(selectedTeamId)
  );
  const assignedTeamCargoQualities = useSelector(
    selectVisibleCargoQualities(selectedTeamId)
  );
  const assignedTeamCargoRequirements = useSelector(
    selectVisibleCargoRequirements(selectedTeamId)
  );

  const cargoTypesSelection = isTeamsCargosTypesQualitiesRequirementsEnabled
    ? assignedTeamCargoTypes
    : cargoTypes;
  const cargoQualitySelection = isTeamsCargosTypesQualitiesRequirementsEnabled
    ? assignedTeamCargoQualities
    : cargoQualityValues;
  const cargoRequirementsSelection =
    isTeamsCargosTypesQualitiesRequirementsEnabled
      ? assignedTeamCargoRequirements
      : cargoQualityValues;

  useEffect(() => {
    dispatch(loadTeams());
  }, [dispatch]);

  const { t } = useTranslation("types");
  const cargoTypeSelectableOptions = useMemo(
    () =>
      cargoTypesSelection.map((id) => ({
        value: id,
        label: t("cargoTypes.type", { context: id }),
      })),
    [t, cargoTypesSelection]
  );
  const cargoQualitiesSelectableOptions = useMemo(
    () =>
      cargoQualitySelection.map((id) => ({
        id,
        label: t("cargoQualities.type", { context: id }),
      })),
    [t, cargoQualitySelection]
  );
  const trailerQualitiesSelectableOptions = useMemo(
    () =>
      cargoRequirementsSelection.map((id) => ({
        id,
        label: t("trailerQualities.type", { context: id }),
      })),
    [t, cargoRequirementsSelection]
  );

  return {
    cargoTypeSelectableOptions,
    cargoQualitiesSelectableOptions,
    trailerQualitiesSelectableOptions,
  };
};

export default useShipmentFormSelectTeamRelatedOptions;
